// extracted by mini-css-extract-plugin
export default {"tr":"DocumentsTabListItemUploading_tr__dWhV0","td_input":"DocumentsTabListItemUploading_td_input__iTn8I","locked":"DocumentsTabListItemUploading_locked__5mRzq"};